import script from "./UserSubscriptionDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSubscriptionDetails.vue?vue&type=script&setup=true&lang=js"

import "./UserSubscriptionDetails.vue?vue&type=style&index=0&id=2178ce94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2178ce94"]])

export default __exports__